export const commonStyle = {
  pc: "1025px",
  tablet: `(min-width: 720px) and (max-width: 1025px)`,
};
